/**
 * Navbar Component
 * 
 * SPA Constitution - Page Lifecycle Law:
 * - render() returns HTML
 * - mount() attaches event listeners
 * - unmount() cleans up
 */
import { APP_ROUTES } from '../config/paths.js?v=20260321h';

export function Navbar(props = {}) {
  const { links = [], title = 'App', user = null } = props;
  const hasUser = Boolean(user && typeof user === 'object');

  const esc = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  return {
    render() {
      const navLinks = links.map(link => 
        `<a href="${link.href}" class="nav-link">${link.label}</a>`
      ).join('');

      const userSection = hasUser
        ? `
          <div class="nav-account" id="nav-account">
            <button id="account-menu-btn" class="nav-account-btn" type="button" aria-haspopup="menu" aria-expanded="false" aria-label="Account menu">
              <i class="far fa-user-circle" aria-hidden="true" style="font-size:1.25rem;"></i>
            </button>
            <div id="account-menu" class="nav-account-menu" role="menu" aria-label="Account actions">
              <div class="nav-account-name">${esc(user.username || 'Account')}</div>
              <button id="logout-btn" class="nav-account-item" type="button" role="menuitem">
                <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
                <span>Logout</span>
              </button>
            </div>
          </div>
        `
        : `<a href="${APP_ROUTES.login}" class="nav-link nav-login" aria-label="Login">
             <i class="far fa-user-circle" aria-hidden="true" style="font-size:1.05rem;color:var(--ink-2)"></i>
             <span class="sr-only">Login</span>
           </a>`;

      return `
        <nav class="navbar">
          <div class="navbar-brand">
            <a href="/">${title}</a>
          </div>
          <div class="navbar-links">
            ${navLinks}
          </div>
          <div class="navbar-user">
            ${userSection}
          </div>
        </nav>
      `;
    },

    mount() {
      this._logoutHandler = null;

      const logoutBtn = document.getElementById('logout-btn');

      if (logoutBtn) {
        this._logoutHandler = (event) => {
          event.preventDefault();
          if (props.onLogout) {
            props.onLogout();
          }
        };
        logoutBtn.addEventListener('click', this._logoutHandler);
      }
    },

    unmount() {
      const logoutBtn = document.getElementById('logout-btn');
      if (logoutBtn && this._logoutHandler) {
        logoutBtn.removeEventListener('click', this._logoutHandler);
      }
    }
  };
}
